export enum HsScheduledJobJobChangeSettingEnum {
  NOT_ENABLED = 'Not enabled',
  DO_NOTHING = 'Do nothing',
  CREATE_NEW = 'Create new',
  CREATE_AND_LINK = 'Create and link',
}
